<script setup lang="ts">
import { useScrollEffect } from "../../composables/useScrollEffect";
import { TabConfig } from "../../../types/tabs";
import { ProductType } from "../../../types/common";
import { dataLayerSearchWidgetTabClick } from "../../analytics/package-search-form";
import { USER_GROUP } from "vacv-components";

export interface Props {
  tabs: TabConfig[];
  audience: USER_GROUP;
  activeTab: string;
}

const { horizontalScroller, showBlurLeft, showBlurRight, scrollIntoView } =
  useScrollEffect();

const props = defineProps<Props>();

const emit = defineEmits(["select"]);

const selectTab = (event: Event, tab: TabConfig) => {
  const productType = tab.label.en;
  scrollIntoView(event.target as HTMLElement);
  dataLayerSearchWidgetTabClick(productType as ProductType);
  emit("select", tab.id);
};

const isSelected = (tabKey: string): boolean => {
  return props.activeTab === tabKey;
};
</script>

<template>
  <nav
    class="search-tabs-wrapper"
    :class="{ blurLeft: showBlurLeft, blurRight: showBlurRight }"
  >
    <div
      ref="horizontalScroller"
      class="search-tablist-scroller"
      role="tablist"
    >
      <template v-for="tab in tabs" :key="tab.id">
        <a
          v-if="tab.searchType === 'link'"
          class="search-tab-btn"
          :class="{ active: isSelected(tab.id) }"
          role="link"
          :href="tab.linkHref"
          :target="tab.linkTarget"
          @click="dataLayerSearchWidgetTabClick(tab.label.en as ProductType)"
          v-html="tab.linkLabel"
        ></a>
        <button
          v-else
          class="search-tab-btn"
          :class="{ active: isSelected(tab.id) }"
          role="tab"
          :id="'btn-' + tab.id"
          :aria-selected="isSelected(tab.id)"
          :aria-controls="tab.id"
          @click.prevent="selectTab($event, tab)"
          v-html="tab.linkLabel"
        ></button>
      </template>
    </div>
  </nav>
</template>
